export default {
  currentUser: {
    userId: '',
    username: '',
    mobile: '',
    name: '',
    companyCode: '',
    adminLocations: ''
  },

  dataEditStaff: {}
}
